export default __webpack_public_path__ + "static/media/remove.38b48d68.svg";